import { combineReducers } from "redux";
import constants from "modules/google/constants";
import createApiReducer from "reducers/createReducers";

const reducers = combineReducers({
  showNoAdsToastResult: createApiReducer(constants.SHOW_NO_ADS_TOAST, {
    value: false,
  }),
  getUserInfoResult: createApiReducer(constants.SET_GOOGLE_USER_INFO, {}),
  setSyncedOfflineConversionsResult: createApiReducer(constants.SET_SYNCED_OFFLINE_CONVERSIONS, {}),
  getAccountHierarchyResult: createApiReducer(constants.GET_ACCOUNT_HIERARCHY, {}),
  getBusinessInfoResult: createApiReducer(constants.GET_BUSINESS_INFO, {}),
  getAccountDataResult: createApiReducer(constants.GET_ACCOUNT_DATA, {}),
  getGoogleUserInfoResult: createApiReducer(constants.GET_GOOGLE_USER_INFO, {}),
  autoLinkAccountResult: createApiReducer(constants.AUTO_LINK_ACCOUNT, {}),
  setBusinessAdwordsIdResult: createApiReducer(constants.SET_BUSINESS_ADWORDS_ID, {}),
  setBusinessAdwordsNameResult: createApiReducer(constants.SET_BUSINESS_ADWORDS_NAME, {}),
  setBusinessCanAccessResult: createApiReducer(constants.SET_BUSINESS_CAN_ACCESS, {}),
  getAdwordsConversionsDataResult: createApiReducer(constants.GET_ADWORDS_CONVERSIONS_DATA, {}),
  getAdwordsConversionsLastsendResult: createApiReducer(constants.GET_ADWORDS_CONVERSIONS_LASTSEND, {}),
  createOfflineConversionResult: createApiReducer(constants.CREATE_OFFLINE_CONVERSION, {}),
  getLinkAccountStatusResult: createApiReducer(constants.GET_LINK_ACCOUNT_STATUS, {}),
  getBusinessPipelinesResult: createApiReducer(constants.GET_BUSINESS_PIPELINES, {}),
  getBusinessStepsResult: createApiReducer(constants.GET_BUSINESS_STEPS, {}),
  getAdwordsPipelineConversionsDataResult: createApiReducer(constants.GET_ADWORDS_PIPELINE_CONVERSIONS_DATA, {}),
  createAdwordsPipelineConversionsDataResult: createApiReducer(constants.CREATE_ADWORDS_PIPELINE_CONVERSIONS_DATA, {}),
  getOfflineConversionAddonResult: createApiReducer(constants.GET_OFFLINE_CONVERSION_ADDON, {}),
  updateOfflineConversionAddonResult: createApiReducer(constants.UPDATE_OFFLINE_CONVERSION_ADDON, {}),
  changeSettingPageResult: createApiReducer(constants.CHANGE_SETTING_PAGE, {
    page: "signin",
  }),
  getLeadStepsResult: createApiReducer(constants.GET_LEAD_STEPS, {}),

  setRwidgetConversionDefaultValueResult: createApiReducer(constants.SET_RWIDGET_CONVERSION_DEFAULT_VALUE, {}),
  getGoogleSheetsListResult: createApiReducer(constants.GET_GOOGLE_SHEETS_LIST, {}),
  getGoogleExchangeTokenResult: createApiReducer(constants.GET_GOOGLE_EXCHANGE_TOKEN, {}),
  setGoogleAccountResult: createApiReducer(constants.SET_GOOGLE_ACCOUNT, {}),
  getGoogleAccountResult: createApiReducer(constants.GET_GOOGLE_ACCOUNT, {}),
  setGoogleSheetsSettingResult: createApiReducer(constants.SET_GOOGLE_SHEETS_SETTING, {}),
  getGoogleAdsLeadFormResult: createApiReducer(constants.GET_GOOGLE_ADS_LEAD_FORM, {}),
  changeGoogleAdsFormSelectTypeResult: createApiReducer(constants.CHANGE_GOOGLE_ADS_FORM_SELECT_TYPE, {
    selectType: "",
  }),
  setCheckedGoogleAdsFormItemsResult: createApiReducer(constants.SET_CHECKED_GOOGLE_ADS_FORM_ITEMS, { items: [] }),
  setGoogleLeadGoogleConnectedResult: createApiReducer(constants.SET_GOOGLE_LEAD_GOOGLE_CONNECTED, {
    googleConnected: false,
  }),
  setGoogleLeadGoogleDisconnectedResult: createApiReducer(constants.SET_GOOGLE_LEAD_GOOGLE_DISCONNECTED, {
    googleDisconnected: false,
  }),
  changeGoogleLeadSheetsUrlInputResult: createApiReducer(constants.CHANGE_GOOGLE_LEAD_SHEETS_URL_INPUT, {
    sheetsUrl: "",
  }),
  setGoogleAdsLeadFormSettingResult: createApiReducer(constants.SET_GOOGLE_ADS_LEAD_FORM_SETTING, {}),
  setGoogleSheetsGGLeadsSettingResult: createApiReducer(constants.SET_GOOGLE_SHEETS_GG_LEADS_SETTING, {}),
  getAllGoogleLeadFormSettingsResult: createApiReducer(constants.GET_ALL_GOOGLE_LEAD_FORM_SETTINGS, {}),
  switchGoogleLeadFormStatusResult: createApiReducer(constants.SWITCH_GOOGLE_LEAD_FORM_STATUS, {}),
  archiveGoogleLeadFormSettingResult: createApiReducer(constants.ARCHIVE_GOOGLE_LEAD_FORM_SETTING, {}),
  getGoogleAdsSettingResult: createApiReducer(constants.GET_GOOGLE_ADS_SETTING, {}),
  getGoogleSheetsSettingResult: createApiReducer(constants.GET_GOOGLE_SHEETS_SETTING, {}),
  getGoogleLeadCRMSettingResult: createApiReducer(constants.GET_GOOGLE_LEAD_CRM_SETTING, {}),
  getGoogleLeadFormSettingResult: createApiReducer(constants.GET_GOOGLE_LEAD_FORM_SETTING, {}),
  setValidateGoogleLeadFormResult: createApiReducer(constants.SET_VALIDATE_GOOGLE_LEAD_FORM, { validateForm: {} }),
  setValidateGoogleSheetsUrlResult: createApiReducer(constants.SET_VALIDATE_GOOGLE_SHEETS_URL, { validateSheets: {} }),
  setValidateGGLeadsGoogleSheetsUrlResult: createApiReducer(constants.SET_VALIDATE_GG_LEADS_GOOGLE_SHEETS_URL, {
    validateSheets: {},
  }),
  setDuplicateGoogleFormResult: createApiReducer(constants.SET_DUPLICATE_GOOGLE_FORM, { duplicateGGForm: {} }),
  getGoogleSheetsOfflineConversionsValueResult: createApiReducer(
    constants.GET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_VALUE,
    {},
  ),
  setGoogleSheetsOfflineConversionsValueResult: createApiReducer(
    constants.SET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_VALUE,
    {},
  ),
  getGoogleSheetsOfflineConversionsLastSentResult: createApiReducer(
    constants.GET_GOOGLE_SHEETS_OFFLINE_CONVERSIONS_LAST_SENT,
    {},
  ),
  updateGGLeadFormSettingErrorStatusResult: createApiReducer(constants.UPDATE_GG_LEAD_FORM_SETTING_ERROR_STATUS, {}),
  setFileInfoErrorResult: createApiReducer(constants.SET_FILE_INFO_ERROR, { fileInfoError: "" }),
  setGoogleLoadingResult: createApiReducer(constants.SET_GOOGLE_LOADING, { loading: false }),
  setGoogleSheetsLoadingResult: createApiReducer(constants.SET_GOOGLE_SHEETS_LOADING, { loading: false }),
  setGoogleSheetsErrorResult: createApiReducer(constants.SET_GOOGLE_SHEETS_ERROR, { error: false }),
  setGoogleAdsLoadingResult: createApiReducer(constants.SET_GOOGLE_ADS_LOADING, { loading: false }),
  setGGConnectionLoadingResult: createApiReducer(constants.SET_GG_CONNECTION_LOADING, { loading: false }),
});

export default reducers;
